import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import api from "../../api";
import Building from "../../assets/img/building.svg";
import Hidden from "@material-ui/core/Hidden";
import WarningIcon from "assets/img/Warning";
import SuccessIcon from "assets/img/Success";
import Warning from "components/Typography/Warning";
import Danger from "components/Typography/Danger";
import { useSelector, useDispatch } from "react-redux";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Tooltip from "@material-ui/core/Tooltip";
import { Grid, Card, CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import {
  redColor,
  yellowColor,
  greenColor,
  whiteColor,
  greyColor,
  blackColor,
  blueColor,
  hexToRgb,
} from "assets/jss/material-dashboard-react.js";
import FieldDeviceGraphs from "./FieldDeviceGraphs";
import { Blink } from "@bdchauvette/react-blink";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";

const StyledTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: "#FEE8DA",
    fontSize: "12px",
  },
})(Tooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  buildingImg: {
    height: "85vh",
    "@media (min-width:0px) and (max-width:599.95px)": {
      width: "16vw",
    },
    "@media (min-width:600px) and (max-width:959.95px)": {
      width: "16vw",
    },
    "@media (min-width:960px) and (max-width:1279.95px)": {
      width: "30vw",
      marginTop: "18vh",
      height: "64vh",
    },
    "@media (min-width:1280px) and (max-width:1919.95px)": {
      width: "25vw",
    },
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      width: "24vw",
      height: "92vh",
    },
  },
}));

// ─── Reusable MetricCard ───────────────────────────────────────────────────────
const MetricCard = ({ label, value, unit, valueColor = "#222222" }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 10px",
      minHeight: "30px",
      height: "100%",        // ← scales with viewport height
      maxHeight: "92px",
      borderRadius: "6px",
      border: "1.5px solid #bdbdbd",
      backgroundColor: "#ffffff",
      boxSizing: "border-box",
    }}
  >
    <span
      style={{
        color: "#0123B4",
        fontWeight: 700,
        fontSize: "clamp(10px, 0.9vw, 9px)",
        letterSpacing: "0.3px",
        fontFamily: "BwSeidoRound-Bold, Arial, sans-serif",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
    <span
      style={{
        color: valueColor,
        fontWeight: 700,
        fontSize: "clamp(10px, 0.9vw, 9px)",
        letterSpacing: "0.2px",
        fontFamily: "BwSeidoRound-Bold, Arial, sans-serif",
        whiteSpace: "nowrap",
        marginLeft: "6px",
      }}
    >
      {value === "-" || value === undefined || value === null
        ? "-"
        : unit
          ? `${value} ${unit}`
          : value}
    </span>
  </div>
);

// ─── Reusable SectionHeader ────────────────────────────────────────────────────
const SectionHeader = ({ title }) => (
  <div style={{ marginBottom: "4px", marginTop: "0px" }}>
    <span
      style={{
        color: "#0123B4",
        fontWeight: 700,
        fontSize: "11px",
        letterSpacing: "0.4px",
        fontFamily: "BwSeidoRound-Bold, Arial, sans-serif",
      }}
    >
      {title}
    </span>
  </div>
);

// ─── Main Component ────────────────────────────────────────────────────────────
export default function GlUps(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const buildingID = useSelector((state) => state.isLogged.data.building.id);
  const alerts = useSelector((state) => state.alarm.alarmData);
  const [isBreakPoints, setIsBreakPoints] = useState("");
  const [data, setData] = React.useState([]);
  const [gateWayStatus, setGateWayStatus] = useState(0);
  const [gateWay, setGateWay] = useState(0);
  const [devCriticalPresent, setDevCriticalPresent] = useState(0);
  const [devNonCriticalPresent, setDevNonCriticalPresent] = useState(0);
  const [deviceStatus, setDeviceStatus] = useState(0);

  // Energy Generation
  const [dgTotalPower, setDgTotalPower] = useState(0);
  const [TransformerTotalPower, setTransformerTotalPower] = useState(0);
  const [solarPower, setSolarPower] = useState("-");

  // Energy Consumption
  const [liftTotalPower, setLiftTotalPower] = useState(0);
  const [sdbTotalPower, setsdbTotalPower] = useState(0);
  const [ltTotalPower, setltTotalPower] = useState(0);
  const [CarChargerTotalPower, setCarChargerTotalPower] = useState(0);
  const [upsTotalPower, setupsTotalPowerr] = useState(0);
  const [vrbTotalPower, setVrbTotalPower] = useState(0);
  const [lightPowerTotal, setLightPowerTotal] = useState(0);

  // Solar Detail
  const [solarTodayNew, setSolarTodayNew] = useState("-");
  const [solarActivePowerNew, setSolarActivePowerNew] = useState("-");
  const [solarFreqNew, setSolarFreqNew] = useState("-");
  const [solarTotalNew, setSolarTotalNew] = useState("-");

  // Fire Alarm
  const [fireAlarmActive, setFireAlarmActive] = useState(null);

  // AQI
  const [tempData, setTempData] = useState("-");
  const [rhData, setRhData] = useState("-");
  const [co2Data, setCo2Data] = useState("-");
  const [pm25Data, setPm25Data] = useState("-");

  // Power consumption states
  const [totalConsumption, setTotalConsumption] = useState("-");
  const [netConsumption, setNetConsumption] = useState("-");
  const [dailyConsumption, setDailyConsumption] = useState(null);
  const [monthlyConsumption, setMonthlyConsumption] = useState(null);
  const [loadingEnergy, setLoadingEnergy] = useState(false);

  const [tempFloorIssue, setTempFloorIssue] = useState({ tempissue: [], tempData: "" });
  const [humFloorIssue, setHumFloorIssue] = useState({ humissue: [], humData: "" });
  const [luxFloorIssue, setLuxFloorIssue] = useState({ luxissue: [], luxData: "" });
  const [airFloorIssue, setAirFloorIssue] = useState({ airissue: [], airData: "" });

  const [openerr, setOpenerr] = React.useState(false);
  const [errmsg, setErrmsg] = React.useState("");

  useEffect(() => {
    localStorage.setItem("floorName", "ATL_0_Ground");
    localStorage.setItem("floorID", "012134f3-86f1-11ef-ab27-00d8611d53a9");

    if (localStorage.getItem("roleID") == "6") {
      let timer = setInterval(() => {
        if (localStorage.getItem("buildingID") !== null) {
          api.notifications
            .alarm(buildingID)
            .then((res) => {
              dispatch({ type: "alarm", payload: res });
            })
            .catch((error) => {
              setOpenerr(true);
              console.log("newdashboard alarms error", error);
            });
        } else {
          clearInterval(timer);
        }
      }, 5000);
    }

    api.campus.glZones(buildingID).then((result) => {
      dispatch({ type: "location", payload: result });
    });

    api.floor.cpmGetDevData().then((res) => {
      const dgData = res["NONGL_SS_DG_ENERGY_METER"];
      const transformerData = res["NONGL_SS_ENERGY_METER_TRANSFORMER"];
      const liftData = res["NONGL_SS_ENERGY_METER_LIFT"];
      const sdbData = res["NONGL_SS_ENERGY_METER_SDB_EMERGENCY"];
      const solarData = res["NONGL_SS_SOLAR_PV_PLANT"];
      const ltData = res["NONGL_SS_ENERGY_METER_LT_PANEL"];
      const CarData = res["NONGL_SS_ENERGY_METER_CAR_CHARGER"];
      const upsData = res["NONGL_SS_ENERGY_METER_UPS"];
      const vrbData = res["NONGL_SS_ENERGY_METER_VRB"];
      const lightAndPowerData = res["NONGL_SS_ENERGY_METER_LIGHT_AND_POWER"];

      // DG Total Power
      if (dgData) {
        let totalPowerDG = 0;
        Object.entries(dgData).forEach(([deviceId, deviceInfo]) => {
          const dgWatt = deviceInfo?.Eqp_Attributes?.DG_EM_WATT?.presentValue;
          if (dgWatt && !isNaN(parseFloat(dgWatt))) totalPowerDG += parseFloat(dgWatt);
        });
        setDgTotalPower(totalPowerDG / 1000);
      } else {
        setDgTotalPower("-");
      }

      // Transformer Total Power
      if (transformerData) {
        let totalPowerTR = 0;
        Object.entries(transformerData).forEach(([deviceId, deviceInfo]) => {
          const trWh = deviceInfo?.Eqp_Attributes?.EM_TR_Watt?.presentValue;
          if (trWh && !isNaN(parseFloat(trWh))) totalPowerTR += parseFloat(trWh);
        });
        setTransformerTotalPower(totalPowerTR / 1000);
      } else {
        setTransformerTotalPower("-");
      }

      // Lift Total Power
      if (liftData) {
        let totalPowerLT = 0;
        Object.entries(liftData).forEach(([deviceId, deviceInfo]) => {
          const ltWh = deviceInfo?.Eqp_Attributes?.EM_Lift_WATT?.presentValue;
          if (ltWh && !isNaN(parseFloat(ltWh))) totalPowerLT += parseFloat(ltWh);
        });
        setLiftTotalPower(totalPowerLT / 1000);
      } else {
        setLiftTotalPower("-");
      }

      // SDB Total Power
      if (sdbData) {
        let totalPowerSDB = 0;
        Object.entries(sdbData).forEach(([deviceId, deviceInfo]) => {
          const SDBWh = deviceInfo?.Eqp_Attributes?.EM_SDB_Emergency_Schnider_kw?.presentValue;
          if (SDBWh && !isNaN(parseFloat(SDBWh))) totalPowerSDB += parseFloat(SDBWh);
        });
        setsdbTotalPower(totalPowerSDB);
      } else {
        setsdbTotalPower("-");
      }

      // Solar Active Power (for Energy Generation card)
      if (solarData) {
        const firstDeviceId = Object.keys(solarData)[0];
        if (firstDeviceId) {
          const solarValue = solarData[firstDeviceId]?.Eqp_Attributes?.Solar_Active_Power?.presentValue;
          setSolarPower(
            solarValue !== undefined && solarValue !== null ? parseFloat(solarValue) : "-"
          );
        } else {
          setSolarPower("-");
        }
      } else {
        setSolarPower("-");
      }

      // LT Panel Total Power
      if (ltData) {
        let totalPowerlt = 0;
        Object.entries(ltData).forEach(([deviceId, deviceInfo]) => {
          const ltrWh = deviceInfo?.Eqp_Attributes?.EM_LT_WATT?.presentValue;
          if (ltrWh && !isNaN(parseFloat(ltrWh))) totalPowerlt += parseFloat(ltrWh);
        });
        setltTotalPower(totalPowerlt / 1000);
      } else {
        setltTotalPower("-");
      }

      // Car Charger Total Power
      if (CarData) {
        let totalPowerCar = 0;
        Object.entries(CarData).forEach(([deviceId, deviceInfo]) => {
          const carWh = deviceInfo?.Eqp_Attributes?.EM_CAR_Charger_WATT?.presentValue;
          if (carWh && !isNaN(parseFloat(carWh))) totalPowerCar += parseFloat(carWh);
        });
        setCarChargerTotalPower(totalPowerCar / 1000);
      } else {
        setCarChargerTotalPower("-");
      }

      // UPS Total Power
      if (upsData) {
        let totalPowerups = 0;
        Object.entries(upsData).forEach(([deviceId, deviceInfo]) => {
          const upsWh = deviceInfo?.Eqp_Attributes?.EM_UPS_Schnider_kw?.presentValue;
          if (upsWh && !isNaN(parseFloat(upsWh))) totalPowerups += parseFloat(upsWh);
        });
        setupsTotalPowerr(totalPowerups);
      } else {
        setupsTotalPowerr("-");
      }

      // VRB Total Power
      if (vrbData) {
        let totalPowerVrb = 0;
        Object.entries(vrbData).forEach(([deviceId, deviceInfo]) => {
          const vrbVal = deviceInfo?.Eqp_Attributes?.EMS_VRB_KW?.presentValue;
          if (vrbVal && !isNaN(parseFloat(vrbVal))) totalPowerVrb += parseFloat(vrbVal);
        });
        setVrbTotalPower(totalPowerVrb);
      } else {
        setVrbTotalPower("-");
      }

      // Light & Power Total
      if (lightAndPowerData) {
        let totalPowerLight = 0;
        Object.entries(lightAndPowerData).forEach(([deviceId, deviceInfo]) => {
          const lightVal = deviceInfo?.Eqp_Attributes?.EM_Light_Power_Schnider_kw?.presentValue;
          if (lightVal !== undefined && lightVal !== null && !isNaN(parseFloat(lightVal)))
            totalPowerLight += parseFloat(lightVal);
        });
        setLightPowerTotal(totalPowerLight);
      } else {
        setLightPowerTotal("-");
      }

      // Fire Alarm
      const fireData = res["NONGL_SS_FIRE_ALARM_SYSTEM"];
      if (fireData) {
        const isActive = Object.values(fireData).some((d) => {
          const val = d?.Eqp_Attributes?.Fire_Alarm?.presentValue;
          return val !== undefined && val !== null && val !== 0 && val !== "0" && val !== false;
        });
        setFireAlarmActive(isActive);
      } else {
        setFireAlarmActive(false);
      }

      // AQI Sensor Data
      let foundTemp = false, foundRh = false, foundCo2 = false, foundPm25 = false;
      Object.entries(res).some(([key, sensorData]) => {
        if (typeof sensorData !== "object" || sensorData === null) return false;
        return Object.entries(sensorData).some(([deviceId, deviceInfo]) => {
          const attrs = deviceInfo?.Eqp_Attributes;
          if (!attrs) return false;
          if (!foundTemp && attrs["AQI_Base_Temp"]?.presentValue !== undefined) {
            const v = attrs["AQI_Base_Temp"].presentValue;
            if (v !== null && v !== undefined && !isNaN(parseFloat(v))) {
              setTempData(parseFloat(v).toFixed(1));
              foundTemp = true;
            }
          }
          if (!foundRh && attrs["AQI_Base_RH"]?.presentValue !== undefined) {
            const v = attrs["AQI_Base_RH"].presentValue;
            if (v !== null && v !== undefined && !isNaN(parseFloat(v))) {
              setRhData(parseFloat(v).toFixed(1));
              foundRh = true;
            }
          }
          if (!foundCo2 && attrs["AQI_Base_CO2"]?.presentValue !== undefined) {
            const v = attrs["AQI_Base_CO2"].presentValue;
            if (v !== null && v !== undefined && !isNaN(parseFloat(v))) {
              setCo2Data(parseFloat(v).toFixed(1));
              foundCo2 = true;
            }
          }
          if (!foundPm25 && attrs["AQI_Base_PM2.5"]?.presentValue !== undefined) {
            const v = attrs["AQI_Base_PM2.5"].presentValue;
            if (v !== null && v !== undefined && !isNaN(parseFloat(v))) {
              setPm25Data(parseFloat(v).toFixed(1));
              foundPm25 = true;
            }
          }
          return foundTemp && foundRh && foundCo2 && foundPm25;
        });
      });

      // Solar Detail Card Data
      const solarDataForCard = res["NONGL_SS_SOLAR_PV_PLANT"];
      if (solarDataForCard) {
        const firstSolarDeviceId = Object.keys(solarDataForCard)[0];
        if (firstSolarDeviceId) {
          const attrs = solarDataForCard[firstSolarDeviceId]?.Eqp_Attributes || {};

          const todayVal = attrs?.Solar_Today_Solar_Energy?.presentValue;
          setSolarTodayNew(
            todayVal !== undefined && todayVal !== null && !isNaN(parseFloat(todayVal))
              ? parseFloat(todayVal).toFixed(2)
              : "-"
          );

          const activePowerVal = attrs?.Solar_Active_Power?.presentValue / 1000;
          setSolarActivePowerNew(
            activePowerVal !== undefined && activePowerVal !== null && !isNaN(parseFloat(activePowerVal))
              ? parseFloat(activePowerVal).toFixed(2)
              : "-"
          );

          const freqVal = attrs?.Solar_Freq?.presentValue / 100;
          setSolarFreqNew(
            freqVal !== undefined && freqVal !== null && !isNaN(parseFloat(freqVal))
              ? parseFloat(freqVal).toFixed(2)
              : "-"
          );

          const totalVal = attrs?.Solar_Total_Solar_Energy?.presentValue / 1000;
          setSolarTotalNew(
            totalVal !== undefined && totalVal !== null && !isNaN(parseFloat(totalVal))
              ? parseFloat(totalVal).toFixed(2)
              : "-"
          );
        } else {
          setSolarTodayNew("-");
          setSolarActivePowerNew("-");
          setSolarFreqNew("-");
          setSolarTotalNew("-");
        }
      } else {
        setSolarTodayNew("-");
        setSolarActivePowerNew("-");
        setSolarFreqNew("-");
        setSolarTotalNew("-");
      }
    });
  }, [buildingID]);

  const handleclose = () => {
    setOpenerr(false);
    setErrmsg("");
  };

  const onClickIssue = (id, name, param, zone_tag) => {
    let type = name === "Basement" ? "csu" : param;
    props.changeContext("floor");
    props.history.push({
      pathname: `/admin/selector`,
      state: { data: id, param: type, from: "newdashboard" },
    });
    localStorage.setItem("context", "floor");
    localStorage.setItem("floorID", id);
    localStorage.setItem("mapSubType", type);
    localStorage.setItem("floorName", name);
    localStorage.setItem("zone_tag", zone_tag);
  };

  // Safe number formatter
  const fmt = (val, decimals = 2) =>
    typeof val === "number" ? val.toFixed(decimals) : val;

  return (
    <div className={classes.root}>
      <Snackbar
        open={openerr}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          style={{ cursor: "pointer" }}
          severity="error"
          variant="filled"
          onClose={handleclose}
        >
          {errmsg}
        </Alert>
      </Snackbar>

      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={1}>

          {/* ── LEFT: Building Image ── */}
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <Grid container item xs={12} spacing={1} direction="column">
              <Grid item xs={12}>
                <Hidden xsDown>
                  <Hidden smDown>
                    <img
                      src={Building}
                      alt="Building"
                      className={classes.buildingImg}
                    />
                  </Hidden>
                </Hidden>
              </Grid>
            </Grid>
          </Grid>

          {/* ── RIGHT: Dashboard Cards ── */}
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
            <div
              style={{
                borderRadius: "8px",
                border: "1.5px solid #e0e0e0",
                background: "#fff",
                padding: "16px 18px",
                marginTop: "0px",
                width: "105%",
                marginLeft: "-13px",
              }}
            >

              {/* ════ FIRE ALARM ════ */}
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "6px" }}>
                {fireAlarmActive === false ? (
                  <Blink>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, backgroundColor: "#e53935", borderRadius: 50, padding: "5px 16px", color: "#fff", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap", cursor: "default" }}>
                      <NotificationsActiveIcon style={{ fontSize: 18 }} />
                      Fire Alarm
                    </div>
                  </Blink>
                ) : (
                  <Tooltip title="No Alarm" arrow>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, backgroundColor: "#43a047", borderRadius: 50, padding: "5px 16px", color: "#fff", fontWeight: 700, fontSize: 13, whiteSpace: "nowrap", cursor: "default" }}>
                      <NotificationsOffIcon style={{ fontSize: 18 }} />
                      Fire Alarm
                    </div>
                  </Tooltip>
                )}
              </div>

              {/* ════ ENERGY GENERATION ════ */}
              <div style={{ marginBottom: "1px" }}>
                <SectionHeader title="ENERGY GENERATION :" />
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <MetricCard
                      label="DG"
                      value={fmt(dgTotalPower)}
                      unit="KW"
                      valueColor="#222222"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MetricCard
                      label="TRANSFORMER"
                      value={fmt(TransformerTotalPower)}
                      unit="KW"
                      valueColor="#222222"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MetricCard
                      label="SOLAR"
                      value={typeof solarPower === "number" ? solarPower.toFixed(2) : solarPower}
                      unit={typeof solarPower === "number" ? "KW" : ""}
                      valueColor="#222222"
                    />
                  </Grid>
                </Grid>
              </div>

              {/* ════ ENERGY CONSUMPTION ════ */}
              <div style={{ marginBottom: "1px" }}>
                <SectionHeader title="ENERGY CONSUMPTION :" />
                <Grid container spacing={1}>
                  {/* Row 1: LIFT, SDB, UPS, VRV */}
                  <Grid item xs={3}>
                    <MetricCard label="LIFT" value={fmt(liftTotalPower)} unit="KW" />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard label="SDB" value={fmt(sdbTotalPower)} unit="KW" />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard
                      label="UPS"
                      value={typeof upsTotalPower === "number" ? upsTotalPower.toFixed(2) : upsTotalPower}
                      unit={typeof upsTotalPower === "number" ? "KW" : ""}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard
                      label="VRV"
                      value={typeof vrbTotalPower === "number" ? vrbTotalPower.toFixed(2) : vrbTotalPower}
                      unit={typeof vrbTotalPower === "number" ? "KW" : ""}
                    />
                  </Grid>
                  {/* Row 2: LT PANEL, CAR CHARGER, LIGHT & POWER */}
                  <Grid item xs={4}>
                    <MetricCard label="LT PANEL" value={fmt(ltTotalPower)} unit="KW" />
                  </Grid>
                  <Grid item xs={4}>
                    <MetricCard label="CAR CHARGER" value={fmt(CarChargerTotalPower)} unit="KW" />
                  </Grid>
                  <Grid item xs={4}>
                    <MetricCard
                      label="LIGHT & POWER"
                      value={typeof lightPowerTotal === "number" ? lightPowerTotal.toFixed(2) : lightPowerTotal}
                      unit={typeof lightPowerTotal === "number" ? "KW" : ""}
                    />
                  </Grid>
                </Grid>
              </div>

              {/* ════ SOLAR ════ */}
              <div style={{ marginBottom: "1px" }}>
                <SectionHeader title="SOLAR :" />
                <Grid container spacing={1}>
                  <Grid item xs={3}>
                    <MetricCard
                      label="TODAY"
                      value={solarTodayNew}
                      unit={solarTodayNew !== "-" ? "Wh" : ""}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard
                      label="TOTAL"
                      value={solarTotalNew}
                      unit={solarTotalNew !== "-" ? "kWh" : ""}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard
                      label="FREQUENCY"
                      value={solarFreqNew}
                      unit={solarFreqNew !== "-" ? "Hz" : ""}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard
                      label="ACTIVE POWER"
                      value={solarActivePowerNew}
                      unit={solarActivePowerNew !== "-" ? "kW" : ""}
                    />
                  </Grid>
                </Grid>
              </div>

              {/* ════ AQI ════ */}
              <div style={{ marginBottom: "1px" }}>
                <SectionHeader title="AQI :" />
                <Grid container spacing={1}>
                  <Grid item xs={3}>
                    <MetricCard
                      label="TEMP"
                      value={tempData !== "-" ? (parseFloat(tempData) / 10).toFixed(1) : "-"}
                      unit={tempData !== "-" ? "°C" : ""}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard
                      label="RH"
                      value={rhData !== "-" ? (parseFloat(rhData) / 10).toFixed(1) : "-"}
                      unit={rhData !== "-" ? "%" : ""}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard
                      label="CO2"
                      value={co2Data !== "-" ? (parseFloat(co2Data) / 10).toFixed(1) : "-"}
                      unit={co2Data !== "-" ? "ppm" : ""}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <MetricCard
                      label="Pm2.5"
                      value={pm25Data !== "-" ? (parseFloat(pm25Data) / 10).toFixed(1) : "-"}
                      unit={pm25Data !== "-" ? "µg/m³" : ""}
                    />
                  </Grid>
                </Grid>
              </div>

              {/* ════ FIELD DEVICE GRAPHS ════ */}
              <div style={{ marginTop: "8px" }}>
                <div style={{ marginBottom: "4px" }}>
                  <span style={{
                    color: "#0123B4",
                    fontWeight: 700,
                    fontSize: "11px",
                    letterSpacing: "0.4px",
                    fontFamily: "BwSeidoRound-Bold, Arial, sans-serif",
                  }}>
                    ENERGY CONSUPMTION :
                  </span>
                </div>
                <FieldDeviceGraphs />
              </div>

            </div>
          </Grid>

        </Grid>
      </Grid>
    </div>
  );
}